import { useState } from 'react'
import { prepareWebAuthnRegistration } from '../api/prepareWebAuthnRegistration'
import { registerWebAuthn } from '../api/registerWebAuthn'
import { finishWebAuthnRegistration } from '../api/finishWebAuthnRegistration'
import { apiRequest } from '../utils/apiRequest'
import {
  REGISTER,
  REGISTRATION_COMPLETE,
  START_REGISTRATION,
} from '../constants/mfa.setup.steps'

export function useSetupMFAWebAuthn({ isFromSettings = false } = {}) {
  const [state, setState] = useState({
    step: START_REGISTRATION,
    isFromSettings,
    isProcessing: false,
    errorCode: null,
    registrationData: null,
    credential: null,
  })

  const prepare = async () => {
    setState((s) => ({ ...s, isProcessing: true, errorCode: null }))
    try {
      const { web_authn_registration_data: registrationData } =
        await apiRequest(prepareWebAuthnRegistration)
      setState((s) => ({
        ...s,
        registrationData,
        step: REGISTER,
      }))
      const credential = await registerWebAuthn({ registrationData })
      setState((s) => ({
        ...s,
        isProcessing: false,
        credential,
      }))
    } catch (error) {
      setState((s) => ({ ...s, isProcessing: false, errorCode: error.message }))
    }
  }

  const finish = async ({ registrationData, credential }) => {
    setState((s) => ({ ...s, isProcessing: true, errorCode: null }))
    try {
      await apiRequest(finishWebAuthnRegistration, {
        requestId: registrationData?.requestId,
        credential,
      })
      setState((s) => ({
        ...s,
        isProcessing: false,
        step: REGISTRATION_COMPLETE,
      }))
      return true
    } catch (error) {
      setState((s) => ({ ...s, isProcessing: false, errorCode: error.message }))
      return false
    }
  }

  return { ...state, prepare, finish }
}
